<template>
  <el-dialog
    v-if="consultingRoom"
    fullscreen
    :modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
  >
    <div class="relative">
      <div class>
        <div class="text-center text-2xl font-semibold mb-3">
          {{ consultingRoom.name }}
        </div>
        <div class="flex justify-end" v-if="isOwnerWorkspace">
          <el-button type="primary" @click="addDoctor"
            >+ {{ $t("lbl_add_doctors__healthcare_professionals") }}</el-button
          >
        </div>

        <div class="my-3 text-base">
          <div class="row">
            <div class="col-md-6 flex space-x-3">
              <div class="font-bold">{{ $t("lbl_address") }}:</div>
              <div>{{ consultingRoom.Address }}</div>
            </div>
            <div class="col-md-3 flex space-x-3">
              <div class="font-bold">
                {{ $t("lbl_consulting_duration__minutes_") }}:
              </div>
              <div>{{ formatSlotTime(consultingRoom) }}</div>
            </div>
            <div class="col-md-3 flex space-x-3">
              <div class="font-bold">{{ $t("lbl_consulting_fee__vnd_") }}:</div>
              <div>{{ formatPrice(consultingRoom) }}</div>
            </div>
          </div>
        </div>

        <el-table
          class="text-black font-medium text-base w-full"
          row-class-name="text-black text-sm"
          header-cell-class-name="text-black text-sm font-semibold"
          :data="consultingRoom.DoctorWorkTimeSetting"
          border
        >
          <el-table-column :label="$t('lbl_doctors__healthcare_professionals')">
            <template slot-scope="scope">
              <div class="flex items-center">
                <span
                  v-if="
                    scope.row.Doctor &&
                    scope.row.Doctor.User &&
                    scope.row.Doctor.User.avatar
                  "
                  class="img-avatar"
                  :style="
                    'background-image: url(' +
                    getUrlImage(scope.row.Doctor.User.avatar) +
                    ');'
                  "
                ></span>
                <span v-else class="img-avatar">
                  {{
                    scope.row.Doctor.User.name
                      ? scope.row.Doctor.User.name.charAt(0)
                      : scope.row.Doctor.User.Email
                      ? scope.row.Doctor.User.Email.charAt(0)
                      : ""
                  }}
                </span>
                <span class="list-item-name">
                  <span class="d-block mb-0 robo-14-500">
                    {{ scope.row.Doctor.User.name }}
                  </span>
                  <span
                    class="robo-12-400"
                    v-if="scope.row.doctor && scope.row.doctor.user.id"
                  >
                    {{ scope.row.doctor.user && scope.row.doctor.user.email }}
                  </span>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('lbl_note')">
            <template slot-scope="scope">
              <span class="text-blue-800">{{ scope.row.Note }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('lbl_service')">
            <template slot-scope="scope">
              <div class="flex gap-2 items-center">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="cursor-pointer"
                  @click="handleOpenModalConfigService(scope.row)"
                >
                  <mask
                    id="mask0_34868_679"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                  >
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_34868_679)">
                    <path
                      d="M2.91661 20C2.5758 20 2.28226 19.8782 2.036 19.6346C1.78975 19.391 1.66663 19.0962 1.66663 18.75C1.66663 18.4092 1.78975 18.1157 2.036 17.8694C2.28226 17.6232 2.5758 17.5001 2.91661 17.5001H17.0833C17.4241 17.5001 17.7177 17.6219 17.9639 17.8654C18.2102 18.109 18.3333 18.4039 18.3333 18.75C18.3333 19.0908 18.2102 19.3844 17.9639 19.6306C17.7177 19.8769 17.4241 20 17.0833 20H2.91661ZM4.99996 13.6779H6.0304L12.9471 6.77405L12.4231 6.24198L11.9038 5.73078L4.99996 12.6475V13.6779ZM3.74998 14.1747V12.4295C3.74998 12.3291 3.76681 12.2335 3.80046 12.1427C3.83413 12.0519 3.88995 11.9675 3.96794 11.8895L13.0913 2.7869C13.2121 2.66618 13.3491 2.57484 13.5024 2.51288C13.6557 2.45091 13.8141 2.41992 13.9775 2.41992C14.1463 2.41992 14.3068 2.45091 14.4591 2.51288C14.6113 2.57484 14.7521 2.67046 14.8814 2.79973L15.883 3.81415C16.0122 3.93487 16.1057 4.07269 16.1634 4.22759C16.2211 4.38251 16.2499 4.54436 16.2499 4.71315C16.2499 4.86807 16.2211 5.02218 16.1634 5.17548C16.1057 5.32879 16.0122 5.47008 15.883 5.59936L6.78038 14.7019C6.70239 14.7799 6.61799 14.8371 6.52719 14.8734C6.43637 14.9097 6.34074 14.9279 6.24031 14.9279H4.50319C4.28845 14.9279 4.10924 14.856 3.96554 14.7123C3.82183 14.5686 3.74998 14.3894 3.74998 14.1747ZM12.9471 6.77405L12.4231 6.24198L11.9038 5.73078L12.9471 6.77405Z"
                      fill="#5C6277"
                    />
                  </g>
                </svg>

                <span class="">{{
                  scope.row.ServiceLocal && scope.row.ServiceLocal.local_name
                }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('lbl_working_time')">
            <template slot-scope="scope">
              <el-button
                class="border-0 text-base"
                :disabled="!isEdit(scope.row.DoctorID)"
                @click="openSetWorkTime(scope.row.Doctor, scope.row)"
              >
                <el-tooltip
                  :content="$t('lbl_set_working_time')"
                  placement="top"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.8999 12.6599C19.7396 12.4774 19.6512 12.2428 19.6512 11.9999C19.6512 11.757 19.7396 11.5224 19.8999 11.3399L21.1799 9.89989C21.3209 9.74256 21.4085 9.5446 21.4301 9.3344C21.4516 9.12421 21.4061 8.91258 21.2999 8.72989L19.2999 5.2699C19.1948 5.08742 19.0348 4.94277 18.8426 4.85658C18.6505 4.77039 18.4361 4.74705 18.2299 4.7899L16.3499 5.1699C16.1107 5.21932 15.8616 5.17948 15.6498 5.0579C15.4379 4.93631 15.2779 4.74138 15.1999 4.5099L14.5899 2.6799C14.5228 2.48127 14.395 2.30876 14.2245 2.18674C14.0541 2.06471 13.8495 1.99935 13.6399 1.9999H9.6399C9.42183 1.98851 9.20603 2.04882 9.02546 2.17161C8.84489 2.2944 8.70948 2.47291 8.6399 2.6799L8.0799 4.5099C8.0019 4.74138 7.84187 4.93631 7.63001 5.0579C7.41815 5.17948 7.16911 5.21932 6.9299 5.1699L4.9999 4.7899C4.80445 4.76228 4.6052 4.79312 4.42724 4.87853C4.24929 4.96395 4.1006 5.10012 3.9999 5.2699L1.9999 8.72989C1.89106 8.91054 1.84212 9.12098 1.86008 9.33112C1.87804 9.54126 1.96198 9.74034 2.0999 9.89989L3.3699 11.3399C3.53022 11.5224 3.61863 11.757 3.61863 11.9999C3.61863 12.2428 3.53022 12.4774 3.3699 12.6599L2.0999 14.0999C1.96198 14.2595 1.87804 14.4585 1.86008 14.6687C1.84212 14.8788 1.89106 15.0892 1.9999 15.2699L3.9999 18.7299C4.10499 18.9124 4.26502 19.057 4.45715 19.1432C4.64928 19.2294 4.86372 19.2527 5.0699 19.2099L6.9499 18.8299C7.18911 18.7805 7.43815 18.8203 7.65001 18.9419C7.86187 19.0635 8.0219 19.2584 8.0999 19.4899L8.7099 21.3199C8.77948 21.5269 8.91489 21.7054 9.09546 21.8282C9.27603 21.951 9.49183 22.0113 9.7099 21.9999H13.7099C13.9195 22.0004 14.1241 21.9351 14.2945 21.8131C14.465 21.691 14.5928 21.5185 14.6599 21.3199L15.2699 19.4899C15.3479 19.2584 15.5079 19.0635 15.7198 18.9419C15.9316 18.8203 16.1807 18.7805 16.4199 18.8299L18.2999 19.2099C18.5061 19.2527 18.7205 19.2294 18.9126 19.1432C19.1048 19.057 19.2648 18.9124 19.3699 18.7299L21.3699 15.2699C21.4761 15.0872 21.5216 14.8756 21.5001 14.6654C21.4785 14.4552 21.3909 14.2572 21.2499 14.0999L19.8999 12.6599ZM18.4099 13.9999L19.2099 14.8999L17.9299 17.1199L16.7499 16.8799C16.0297 16.7327 15.2805 16.855 14.6445 17.2237C14.0085 17.5924 13.53 18.1817 13.2999 18.8799L12.9199 19.9999H10.3599L9.9999 18.8599C9.76975 18.1617 9.29128 17.5724 8.6553 17.2037C8.01932 16.835 7.27012 16.7127 6.5499 16.8599L5.3699 17.0999L4.0699 14.8899L4.8699 13.9899C5.36185 13.4399 5.63383 12.7278 5.63383 11.9899C5.63383 11.252 5.36185 10.5399 4.8699 9.98989L4.0699 9.0899L5.3499 6.88989L6.5299 7.1299C7.25012 7.27712 7.99932 7.15478 8.6353 6.78609C9.27128 6.41741 9.74975 5.82805 9.9799 5.1299L10.3599 3.9999H12.9199L13.2999 5.13989C13.53 5.83805 14.0085 6.42741 14.6445 6.79609C15.2805 7.16478 16.0297 7.28712 16.7499 7.13989L17.9299 6.8999L19.2099 9.11989L18.4099 10.0199C17.9235 10.5687 17.6549 11.2766 17.6549 12.0099C17.6549 12.7432 17.9235 13.4511 18.4099 13.9999ZM11.6399 7.9999C10.8488 7.9999 10.0754 8.23449 9.41761 8.67402C8.75982 9.11354 8.24713 9.73826 7.94438 10.4692C7.64163 11.2001 7.56241 12.0043 7.71675 12.7803C7.8711 13.5562 8.25206 14.2689 8.81147 14.8283C9.37088 15.3877 10.0836 15.7687 10.8595 15.923C11.6355 16.0774 12.4397 15.9982 13.1706 15.6954C13.9015 15.3927 14.5262 14.88 14.9658 14.2222C15.4053 13.5644 15.6399 12.791 15.6399 11.9999C15.6399 10.939 15.2185 9.92161 14.4683 9.17147C13.7182 8.42132 12.7008 7.9999 11.6399 7.9999ZM11.6399 13.9999C11.2443 13.9999 10.8577 13.8826 10.5288 13.6628C10.1999 13.4431 9.94351 13.1307 9.79214 12.7653C9.64076 12.3998 9.60116 11.9977 9.67833 11.6097C9.7555 11.2218 9.94598 10.8654 10.2257 10.5857C10.5054 10.306 10.8618 10.1155 11.2497 10.0383C11.6377 9.96115 12.0398 10.0008 12.4053 10.1521C12.7707 10.3035 13.0831 10.5599 13.3028 10.8888C13.5226 11.2177 13.6399 11.6043 13.6399 11.9999C13.6399 12.5303 13.4292 13.039 13.0541 13.4141C12.679 13.7892 12.1703 13.9999 11.6399 13.9999Z"
                      fill="#656d77"
                    />
                  </svg>
                </el-tooltip>
              </el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column label="Tình trạng">
            <template slot-scope="scope">
              <el-dropdown
                trigger="click"
                @command="
                  (command) => {
                    handleCommand(command, scope.row);
                  }
                "
                :disabled="!isEdit(scope.row.DoctorID)"
              >
                <span class="el-dropdown-link">
                  <div v-if="scope.row.Status === 1">
                    <span class="text-green-600 text-sm">Hoạt động</span
                    ><i class="el-icon-arrow-down el-icon--right"></i>
                  </div>
                  <div v-if="scope.row.Status === 0">
                    <span class="text-red-500 text-sm">Tạm dừng</span
                    ><i class="el-icon-arrow-down el-icon--right"></i>
                  </div>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a"
                    ><span v-if="scope.row.Status === 1">Hoạt động</span>
                    <span v-if="scope.row.Status === 0">Tạm dừng</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>-->
        </el-table>

        <div v-if="isOwnerWorkspace" class="flex justify-between items-center">
          <!-- <div class="space-x-3 flex">
            <el-button
              class="text-base"
              icon="el-icon-delete"
              type="danger"
              :disabled="loading"
              @click="onCRDelete()"
              >Xóa Phòng Tư vấn</el-button
            >
            <div
              class="
                w-40
                flex
                justify-center
                items-center
                h-10
                border-item
                rounded-xl
              "
              :class="
                consultingRoom.Status === 1  ? 'border-item-green' : 'border-item-red'
              "
            >
              <el-dropdown
                trigger="click"
                @command="
                  (command) => {
                    handleToggleStatusCR(command, consultingRoom);
                  }
                "
              >
                <span class="el-dropdown-link">
                  <div v-if="consultingRoom.Status === 1">
                    <span class="text-green-600 text-sm">Hoạt động</span
                    ><i class="el-icon-arrow-down el-icon--right"></i>
                  </div>
                  <div v-if="consultingRoom.Status === 0">
                    <span class="text-red-500 text-sm">Tạm dừng</span
                    ><i class="el-icon-arrow-down el-icon--right"></i>
                  </div>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a"
                    ><span v-if="consultingRoom.Status === 0">Hoạt động</span>
                    <span v-if="consultingRoom.Status === 1">Tạm dừng</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>-->
          <div class="flex justify-end mt-3">
            <el-button
              class="border-0 text-base"
              @click="handleClose"
              :disabled="loading"
              >{{ $t("lbl_cancel") }}</el-button
            >
            <el-button
              class="text-white text-sm"
              type="primary"
              @click="editPrescription(consultingRoom.ID)"
              :disabled="loading"
            >
              <div>{{ $t("lbl_edit") }}</div>
            </el-button>
          </div>
        </div>
        <div v-else class="flex justify-end mt-3">
          <el-button
            class="border-0 text-base"
            @click="handleClose"
            :disabled="loading"
            >{{ $t("lbl_cancel") }}</el-button
          >
        </div>
      </div>
      <ModalAddConsultingRoom
        ref="ModalAddConsultingRoom"
        @refresh="getConsultingRoomByID"
      />

      <ModalAddDoctor
        ref="ModalAddDoctor"
        @refresh="getConsultingRoomByID"
        :members="doctors"
      />

      <el-dialog
        :title="slt_dtr && slt_dtr.User.name"
        :visible.sync="modal_work_time"
        width="100%"
        fullscreen
        append-to-body
      >
        <CRWorkTime
          v-if="modal_work_time"
          :doctorWorkTimeSettingId="doctorWorkTimeSettingId"
          :slot-duration="slotDuration"
          :doctor_name="slt_dtr && slt_dtr.User.name"
          :cr_id="consultingRoom && consultingRoom.ID"
          @refresh="modal_work_time = false"
        />
      </el-dialog>
      <ModalConfigServiceForDoctor
        ref="ModalConfigServiceForDoctor"
        @onRefresh="getConsultingRoomByID(consultingRoom.ID)"
      />
    </div>
  </el-dialog>
</template>
  
  
<script>
import appUtils from '../../../utils/appUtils'
import moment from 'moment'
import ModalAddConsultingRoom from './ModalAdd'
import ModalAddDoctor from './ModalAddDoctor.vue'
import CRWorkTime from './ModalWorkTimes.vue'
import ModalConfigServiceForDoctor from './ModalConfigServiceForDoctor.vue'

export default {
  name: 'ModalViewConsultingRoom',
  props: ['isOwnerWorkspace'],
  components: {
    ModalAddConsultingRoom,
    ModalAddDoctor,
    CRWorkTime,
    ModalConfigServiceForDoctor
  },
  data () {
    return {
      dialogVisible: false,
      consultingRoom: {},
      loading: false,
      doctors: [],
      slt_dtr: null,
      doctorWorkTimeSettingId: null,
      slotDuration: null,
      modal_work_time: false,
      appUtils
    }
  },
  methods: {
    isEdit (doctor_id) {
      // console.log(doctor_id)
      if (this.isOwnerWorkspace) return true
      const user = this.$user
      if (!doctor_id || !user || !user.doctor) return
      return doctor_id === user.doctor.id
    },
    handleClose () {
      this.dialogVisible = false
      this.cancel()
    },
    openDialog (id) {
      this.dialogVisible = true
      this.$nextTick(() => {
        if (id) {
          this.getConsultingRoomByID(id)
        }
      })
    },
    cancel () {
      this.consultingRoom = {}
    },
    formatDate (date) {
      return date && moment(date).format('DD/MM/YYYY')
    },
    editPrescription () {
      this.$refs.ModalAddConsultingRoom.openDialog(this.consultingRoom)
    },
    getUrlImage (path) {
      return appUtils.getImageURL(path)
    },
    async getConsultingRoomByID (id) {
      try {
        if (id) {
          // const params = {
          //   page: 1,
          //   limit: 20,
          //   sort_by: 'acs',
          //   sort: 'id'
          // }
          await this.$rf
            .getRequest('DoctorRequest')
            .getConsultingRoomByIDV2(id)
            .then((res) => {
              console.log(res)
              this.consultingRoom = res.data.data
              // this.getConsultingRoomDoctors()
              this.$emit('refresh')
            })
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getConsultingRoomDoctors () {
      try {
        if (this.consultingRoom) {
          const params = {
            cr_id: this.consultingRoom.id
          }
          await this.$rf
            .getRequest('DoctorRequest')
            .getConsultingRoomDoctors(params)
            .then((res) => {
              this.doctors = res.data?.data
            })
        }
      } catch (e) {
        console.log(e)
      }
    },
    formatSlotTime (row) {
      return this.$t('fm_minutes', { minutes: row.Slot_Duration || '' })
    },
    formatPrice (row) {
      if (row?.IsUsingRoomPrice === 1) return 'Theo yêu cầu'

      return appUtils.formatToCurrency({ amount: row.Slot_Price })
    },
    addDoctor () {
      this.$refs.ModalAddDoctor.openDialog(this.consultingRoom.ID)
    },
    openSetWorkTime (dr, row) {
      if (this.isEdit(dr.id)) {
        this.slt_dtr = dr
        this.modal_work_time = true
        this.doctorWorkTimeSettingId = row.ID
        this.slotDuration = this.consultingRoom.Slot_Duration
      }
    },
    async handleCommand (command, row) {
      if (command === 'a') {
        this.$confirm('Chuyển trạng thái')
          .then(async () => {
            await this.$rf
              .getRequest('DoctorRequest')
              .toggleStatusConsultingRoomDoctor(row.ID)
            await this.getConsultingRoomDoctors()
          })
          .catch((e) => {
            console.log(e)
          })
      }
    },
    async handleToggleStatusCR (command, row) {
      if (command === 'a') {
        this.$confirm('Chuyển trạng thái')
          .then(async () => {
            await this.$rf
              .getRequest('DoctorRequest')
              .toggleStatusConsultingRoom(row.ID)
            this.getConsultingRoomByID(row.id)
          })
          .catch((e) => {
            console.log(e)
          })
      }
    },
    onCRDelete () {
      try {
        if (this.consultingRoom) {
          this.$confirm('Xoá Phòng Tư vấn').then(async () => {
            await this.$rf
              .getRequest('DoctorRequest')
              .deleteConsultingRoom(this.consultingRoom.ID)
              .then((res) => {
                this.handleClose()
                this.$emit('refresh')
              })
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    handleOpenModalConfigService (data) {
      this.$refs.ModalConfigServiceForDoctor.handleOpen(data)
    }
  }
}
</script>
  
<style lang="scss">
.border-item-red {
  border: 1px solid red;
}
.border-item-green {
  border: 1px solid green;
}

.img-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  background: #20419b;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>